import { Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    backgroundColor: "#ffffff",
    borderWidth: 1,
    color: "black",
  },
  section: {
    border: 1,
    width: "100%",
  },
});

const VoucherDocumentExpenseList = (props) => {

  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <View
          style={{
            flexDirection: "row",
            fontSize: "13",
            fontFamily: "Roboto",
            padding: "5",
            borderBottom: "1",
          }}
        >
          <Text style={{ width: "20%" }}>Description</Text>
          <Text style={{ width: "12%" }}>Expense Type</Text>
          <Text style={{ width: "12%" }}>payment Type</Text>
          <Text style={{ width: "15%" }}>Amount(Admin)</Text>
          <Text style={{ width: "17%" }}>Reason(Admin)</Text>
          <Text style={{ width: "12%" }}>Bill No</Text>
          <Text style={{ width: "12%" }}>Date</Text>
        </View>
        {props.expenseList?.voucherExpenses?.map((current,index) => {
          return (
            <View
              style={{
                flexDirection: "row",
                fontSize: "11",
                fontFamily: "Roboto",
                fontWeight: "500",
                padding: "5",
              }}
              key={index}
            >
              <Text style={{ width: "20%", paddingHorizontal: "3px" }}>
                {current.description}
              </Text>
              <Text style={{ width: "12%", paddingHorizontal: "3px" }}>
                {current.expenseType}
              </Text>
              <Text style={{ width: "12%", paddingHorizontal: "3px" }}>
                {current.paymentType}
              </Text>
              <Text style={{ width: "15%", paddingHorizontal: "3px" }}>
                {current.adminApprovedAmount}
              </Text>
              <Text style={{ width: "17%", paddingHorizontal: "3px" }}>
                {current.adminApprovedAmountRemark}
              </Text>
              <Text style={{ width: "12%", paddingHorizontal: "3px" }}>
                {current.voucherNo}
              </Text>
              <Text style={{ width: "12%", paddingHorizontal: "3px" }}>
                {current.date}
              </Text>
            </View>
          );
        })}
      </View>
    </Page>
  );
};

export default VoucherDocumentExpenseList;
